import { phoneFormatter } from "./formatPhone";


export interface PhoneValidationResult {
  formatted: string;
  error: string | null;
}

export const validateAndFormatPhone = (inputValue: string): PhoneValidationResult => {
  let digitsOnly = inputValue.replace(/\D/g, "");

  // força o 9 na frente se não existir
  if (digitsOnly.length >= 3) {
    if (digitsOnly[2] !== "9") {
      digitsOnly = digitsOnly.substring(0, 2) + "9" + digitsOnly.substring(2);
    }
  }

  const formatted = phoneFormatter(digitsOnly);

  let error: string | null = null;
  if (digitsOnly.length === 0) {
    error = "Telefone é obrigatório";
  } else if (digitsOnly.length < 11) {
    error = "Telefone incompleto";
  }

  return { formatted, error };
};
